import React from 'react';
import Modal from 'react-modal';

interface ModalWrapperProps {
  appElement: HTMLElement;
  isOpen: boolean;
  onRequestClose?: () => void;
  style?: any;
  contentLabel: string;
  children: React.ReactNode;
}

const ModalWrapper: React.FC<ModalWrapperProps> = props => {
  // Use type assertion to bypass the ReactNode compatibility issue
  const ModalComponent = Modal as any;

  return <ModalComponent {...props} />;
};

export default ModalWrapper;
